export default __webpack_public_path__ + "static/media/typing.da41b3be.png";